var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameOver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 259.8 266.5",
    style: {
      enableBackground: "new 0 0 259.8 266.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#FBCC9A;}\r\n\t.st2{fill:#E52628;}\r\n\t.st3{fill:#E2D138;}\r\n\t.st4{fill:#231F20;}\r\n\t.st5{fill:#504D4D;}\r\n\t.st6{fill:#7C7A7A;}\r\n\t.st7{fill:#2AABE3;}\r\n\t.st8{fill:#D1D4D4;}\r\n\t.st9{fill:#F6F6F6;}\r\n\t.st10{fill:#343233;}\r\n\t.st11{fill:#404042;}\r\n\t.st12{fill:#020203;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 130.3,
    cy: 134.9,
    r: 122.3
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#89CCC6"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.5,111l0.6-6.3l-2.2-9.7c0,0-10.3-1.9-20,0c0,0-10.5-1.8-19.5-0.1l-2.6,9.8l0.5,6.4l-1.3-0.6l-1.6,1.3 l-1.2,5l3.5,8.5l2,1.1l0.7,7l3.9,6c0,0-0.4,5.6-0.9,7.2c0,0,2.2,7.1,13.9,10.7c0,0,1.8,1.6,3,3.7c0,0,1-1.8,1.9-2.5 c0,0,10.7-2.5,14.6-11.8l-0.4-0.5l-1.3-6.2l4.3-6.6l0.6-7l2.3-0.9l3.4-8.2l-0.5-5l-1.7-1.8L162.5,111z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.3,
    y: 45.7,
    className: "st2",
    width: 28.4,
    height: 48.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.6,182.2c0,0-12.6,1.8-19-6.3l-4.6-5.2l3.4,15.4l4.8,7.9h5.4l5.9-2.4l9.1-1.8l2.1-1.5l4.8,0.4l1.8,7.5 l2.3,5.3l5.6,84l2.2,2.5c0,0,21.1,3.7,43.7,4.5c22.5,0.7,34.9-4.8,34.9-4.8l2.4-2.4l4.9-75.4l-33.6-30.8l-2,0l-3.4-3.1l0.6-1.6 l-6-2.2c0,0-1,5-0.6,12l-4.7-1.5c0,0-0.3-11.7,1.2-15.5l-5.3-6c0,0-7.3-3-12.3-10.9l0.8-1.2l-2.8-0.5l-2.5,0.8 c0,0-8.6-0.8-13.7-0.8l-7.7,0.8L84.1,144l-6.9,2l-2.1,0.7h-4c0,0,7.9,7,7.3,18.6C78.4,165.2,78.5,175,77.6,182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.3,200.7l-3.6-4.8l-15-7.8l-13.2,0.2l-1.5-0.5l-10.7-5.4L163.9,167v-1.5L159,162l-1.4,0.5l-2-1.5l-1-2.7 c0,0,4.8-5.1,5.9-8.1l-0.8-1l2.8-0.7l3.2,0.6c0,0,4.4,0.5,14-0.5l5.7,0.6l5.5-1.4l15.4,3.5l6.9,9.6l0.7,5.7l12.4,16.7l4.1,6.8 L234.3,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.6,162.5l-1.2,0.7c0,0-5.3-0.4-5.2,6.3l-2.2,4.8l-6-2.2l-4.2-5l-7.1-8.1l-0.3-5.1l-3-4.7l0-5.6l2-1.1 l1.1-3.5h3l3.1-1.1h2.6l8.9,5.7l6.6,17.4L157.6,162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.9,167c0,0-1.7,0.6-2.6,1.3c0,0,0.1,4.5-4.9,5.2c0,0-2.4,3.7-2.6,5.7l44.9,41.3l15.4,4.8l12.3,1.6 l8.3-6.4l1.8-7.7l-1.8-11.6l-4.1-5.3l-14.7-7.8h-10.5h-4.2l-13.2-7L163.9,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.8,121.9c0,0-6,9-18.4,4.7l0.7,9c0,0,0.3,16.1,4.4,28.1l4.8,7.5c0,0,7,9.2,14.6,10.7l2.6,0.2h6.1 c0,0,1.7-13,0.5-22.1c0,0-0.2-7.1-7-13.5l-3-1.9L62.8,121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.6,105.8l-1.1-10.3l-1.2-1h-3.9l-2.2-2c1.2-0.3,1.9-1.2,2.2-1.6l0.1-2.4L56.3,83L49,80.5L43.6,83v9.5 L37.9,95l-0.1,5.1l-1,2.8l0.9,2.4l-1.3,2.7l3.2,7.8l4.3,4l0,2c11.9,5,17.8-5,17.8-5l-0.5-2.6L66.6,105.8z M49.2,91.9v-4.6l1.1,0.2 l2.6,3.1L49.2,91.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.7,159l-0.3-4.5c-2.9-1.7-5.9-4.4-7.3-8.3l-2.8,3.7c0,0,3.1,6.9,12.3,11.2c0,0,0,0,0,0L131.7,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.1,172.1L143.1,172.1l-4.3-4.9c-0.2,0.7-1.7,5.4-1.2,15.4l4.8,1.7C142.4,184.3,142.2,178.4,143.1,172.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.7,146.6c0,0-1,3.5-4.9,6.9l1.8,4.7c2.2-2,4.4-4.7,5.9-8L157.7,146.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "234.3,200.7 230.7,195.9 216,188.1 205.5,188.1 211,186.7 220.5,187 232.3,194.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "58.6,175.9 54.1,170.7 57.5,186.1 62.3,194 67.7,194 73.6,191.6 68.5,191.6 63.8,191 60.7,185.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.3,146.8l-4.3-0.2c0,0,6.5,5.8,7,13.5c0,0,1.2,2.6-0.7,23.4l-4.3,8.1l2-0.4l4-5.5l1.4-3.1 c0,0,1.8-12.9,1.4-21.6C81.9,161.1,81.9,151.1,75.3,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.9,121l-1.1,0.6l0.1,3.9l1.3,1c0,0,10.6,5,18.6-4.6l0.6-1.3c0,0,0.5-4.4-1.9-5.1l0.3,1.4 c0,0-5.9,10-17.8,5L43.9,121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.9,167c0,0-1.1,0.3-2.6,1.3c0,0,0.2-4.1-4.9-5.1c0,0,0.9-0.9,2.6-1.2l4.9,3.4V167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.4,173.5c0,0-4,0.2-5.2-4c0,0-2.2,4.1-2.7,6.4l3.4,3.3l2-0.1C153.8,179.2,154.1,177.2,156.4,173.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1596 -0.9872 0.9872 0.1596 -34.9578 295.6506)",
    className: "st5",
    cx: 156.2,
    cy: 168.4,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.2,171.2c-2.1,0-3.8-1.5-4.2-3.6c0,0.2-0.1,0.4-0.1,0.7c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2 c0-0.2,0-0.5-0.1-0.7C160,169.7,158.3,171.2,156.2,171.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M136.3,145.4l-3.9-1.8c0,0,3.7-5.1,7.7-5.7l3.2,2.1C143.3,139.9,139,141.9,136.3,145.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "137.3,135.4 140.8,135.4 140.8,138.2 140.1,137.8 137.3,137.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M192.4,183.6c0,0,4.2-19.8,14.3-22.8c0,0-7.3,3.4-12.2,21.6l3.6,3.9L192.4,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.4,161c0,0-9.8,4.7-14.6,15c0,0,6.1-8,15.2-10.4L213.4,161z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "200.3,187.3 210.7,185.6 221.1,185.6 229.3,190.9 230.6,190.2 232.3,194.9 220.5,187 211,186.7  203.9,188.2 201.3,188.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M223.3,183.1c0,0-9.6-1.2-17.8,1.2C205.5,184.3,212.1,180.2,223.3,183.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "234,200.2 230.7,195.9 215.7,188.1 220.7,189 231.2,195.6 233.1,197.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M191,147.8l-1,3.8c0,0-1.1,9.2,0,16.4l-0.5,6.7l-4-25.5L191,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M195.8,168.5c0,0-3.6,6.2-4.4,11l-0.4-2.6l0.4-2.6C191.4,174.2,193.6,170.1,195.8,168.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203.9,188.7c0,0,10.1,2.3,19.4,8.9l-3.3-4.9l0.7-2.1l-4.9-2.5l-11.1,0.1L203.9,188.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "155.3,175.4 201.5,212.9 229.3,217.3 234.8,213.4 234,221.1 226.4,226.8 214.1,225.2 198.7,220.4  153.8,179.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M150.7,170.6c0,0,0.8,3.3,3.1,3.9L152,179h1.7l2.7-5.5c0,0-3.6,0.2-5.2-4L150.7,170.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "160.4,165.6 161.4,168.1 163.9,167 164.1,165.3 162,166.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "130.8,152.9 130.9,150.2 129.9,147.8 129.9,145.1 135.6,149 134.7,155.9 136.3,159 145.1,169.1  148.8,169.5 150.6,170.9 149,174.3 143,172.1 131.7,159 131.4,153.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "131.3,139.4 132.1,141.2 133.6,142.2 132.9,143.5 130.4,142.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "137.1,144.4 136.5,145.4 138.7,146.6 140.1,147.8 139,146.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "136.7,139.4 135.7,138.6 134.7,138.8 136.1,139.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "140.3,142 142.3,143.3 144.4,144.7 142.8,142.7 140.9,141.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M134.4,141.4v1l1.3,1.1l1-0.2c0,0,3.4-3.1,5.9-3.8l1.1,0.5c0,0-5,1.7-7.4,5.3l-3.6-1.9 C132.7,143.4,133.2,142.1,134.4,141.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "137.6,135.9 138.2,137 139.9,137 140.6,135.9 140.8,138.2 140.1,137.8 137.5,137.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "91.3,195.8 94.4,190 94.7,181.8 98,158.4 96.8,154.1 97,158.3 93.7,178.2 91.3,181.6 86.3,188.3  89.7,188.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M75.8,186.7l3.4-0.9l3.7,0.4c0,0,6.5-4,8.2-9.8c0,0-0.8,6.7-9.2,13.6l-6.8,1.3l-2,0.4L75.8,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M78.6,145.6c0,0,7.8,2.4,8.8,16c0,0,2.1-9.1-3.3-17.6L78.6,145.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "98,153.6 99.8,158.3 98,167.2 99.8,164.1 100.5,157.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80.6,182.7l-3.1,0.8l0.8-8.6c0,0-13.7,0.6-23.5-11.6l-1.6-1.7l-0.8-5.4l-4.8-22.4l-1.1-6.7l-2-0.6l0.7,9 c0,0,0.3,15.6,4.4,28.1l4.8,7.5l1.8,2.2l2.4,12.5l4.4,6.7l5,0.3l7.1-1.6l3.9-5.1L80.6,182.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M70.1,146l-1.9-0.6c0,0,1.2,9-0.5,14.3l2.4-8.9v-2.9h2.2l-1.2-1.2L70.1,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M48.4,127.6l-0.9-1.9v-2.3l0.9-2.5c0,0,5.6,1.8,11-5.8c0,0-6.6,7-14.9,0.6l-1.6-2.7l2.6-1.6l-2.6-1.2 l10.3-1.3l1.4-2.1l-0.5-1.9H39.5l2-1.1l12.7-0.3l1.6-1.6l-1.3-2.8H41.4l11.7-2.3h2.1l4.3,3.3l1.6-1.9l-5.8-3.6h-6.5l-6.6,0.6 l3.4-2.5v-8.4l7.1,0.8l3.6-2.1L49,80.5L43.6,83v9.5L37.9,95l-0.1,5.1l-1.1,3.1l1,2.1l-1.1,3l3.1,7.6l4.3,4l-0.1,1.1l-1.1,0.6 l0.1,3.9l1.5,1.1L48.4,127.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "61.3,98.6 59.6,100.1 60.6,100.9 60.5,104.5 58.2,105.9 58.9,106.2 58.2,109.5 53.1,111 57.8,111  59.4,113.4 60.5,106 62,104.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M51.1,51.4v29.8l5.2,1.8l4.3,5.5l-0.1,2.4l-1,1l-1.2,0.6l0.7,0.7h17.3v-3.5C76.3,89.7,52.4,100.5,51.1,51.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "52.3,47.4 76.3,47.4 76.3,75.1 75,48.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "49.2,87.4 50.3,87.6 53,90.7 50.9,91.4 49.2,89.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.6,350H89.6c0,0,1.6-12.9,3.8-22.9l6-26.3l1.9-7.5l0.4-5.3c0,0,31.9,5.5,43.6,4.5c0,0,25.1,0.4,34.9-4.8 l1,5.9C181.1,293.6,187.2,314.6,192.6,350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.5,95.2c0,0-2.6-0.7-4.8,0c0,0-7.7-2.2-19.8-0.2c0,0-10.3-1.7-19.5-0.1c0,0-2.8-0.7-5.5,0.1l0.7-4.3 l2.4-4.3l2.9-3.2l2-1.7l1.6-1.2l1.6-1.1l1.1-0.7c0,0,11.2-7.2,24.2-0.6l1.6,0.9l2.1,1.4l1.9,1.6l3.2,3.3l1.6,2.3l1.2,2.2l0.7,2.3 L165.5,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.8,95l2.5,10.3l2.1-10.3C165.5,95,163.5,94.5,160.8,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M121.3,94.9l-2.8,10.9l-2.7-11.1C115.8,94.7,119.2,94.1,121.3,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M121.3,259c0,0,35.5-10.3,51.4-40.9C172.7,218.1,164.6,252.2,121.3,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M127.1,263.7c0,0,21.4-2.7,28.5-7.9C155.6,255.7,148.8,263.9,127.1,263.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "158,182.8 157.9,198.5 160.2,202.3 177.6,202.8 160.2,204.2 156.7,199.7 155.7,180.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M162.6,148.5v2.1c0,0-3.2,4.9-7.6,8.7l-0.3-0.8c2.1-2.3,4.5-5.4,5.8-8.4l-0.8-1L162.6,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M166.2,151.1c0,0-4.2,8.9-8.7,12.2C157.5,163.3,166.1,157.8,166.2,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M184.1,207c0,0-0.5,54.3-23.6,78c0,0,14.7-30.9,18-58.2c0,0-13.8,54.5-27.5,62l-19.2,1l-6.4-4.1 c0,0-8.5-17.3-9.6-23c0,0,4.5,18.7,5.9,22.3c0,0-13.7-22.6-25.3-85.5l-2.3,3.9l5.3,82.1l2.3,2.6c0,0,50.5,9.8,78.5-0.3l1-3.5 l5-75.5L184.1,207z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117,156.5c0,0,7.2,23.2,14.3,27.9C131.3,184.4,124,184,117,156.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "136.2,180.5 136.6,182.8 143.1,185.1 143.5,183.3 143.9,186.7 135.6,183.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M103.2,148.5l4.3,3.9l7.3-0.2l1.1,1.1l0.6-2.2c0,0,7.2,9.9,17.9,12.2l-0.4-1c0,0-10-3.4-14.2-12.5l0.9-1.1 l-1.4-0.3l-2.5,0.8L103.2,148.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "161.6,119.2 155.7,125.8 151,145 149.8,145.6 151.2,149.1 152.8,148.6 156.1,139.9 160.4,133.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "120.1,119.2 126.4,125.8 130.4,142.4 128.4,143.6 128.4,149.2 130.9,153.3 131.3,154.4 127.8,151.8  131.5,155.3 131.6,156.6 127.5,157.2 121.3,149.9 124.5,146.1 125.3,139.4 121.4,133.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M139.9,168.5c-0.8,3-1.3,6.9-1.1,11.6c0,0,0.4-5.5,1.8-10.7L139.9,168.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "162.2,113.9 163.4,113.4 164.4,113.9 164.7,116.7 163.4,115 161.9,117.5 163.4,120.2 162.2,123.7  161.2,124.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "119.5,113.9 118.3,113.4 117.3,113.9 117,116.7 118.3,115 119.8,117.5 118.3,120.2 119.4,123.7  120.5,124.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M122,94.6l-3.7-0.9h3.4l0.3-1.1l9.4-2.8l5.4,1.8l-3.5-3.1l3.2,1.8l1.5,1.3l-0.9-4.6l1.9,4.5v-4.9l1.9,6 l0.4-1.9l2.6-3.3l-1.5,4.3l4.3-3.4l-2.1,3.1l2.6-1.3l1.9-0.1l-1.4,0.7l2.7-0.4l10.8,1.8l-1.9,0.7l3.7-0.2l-1.7,1l1.7,1.3l-1.7,0.4 c0,0-11.5-1.7-20.2,0C140.9,95,131.1,93.5,122,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.5,111.3l0.6-2.9l0.4-5l2.3-7.6c0,0,10.5-1.3,18.2,0.5c0,0,9.6-1.8,19-0.3l1.7,8.6v7.3l0.6,1.6l0.9-9 l-0.8-3.1l2.2-2.3l-2.7,0.3l-0.3-1.7l3.7-1.8l-4.3,0.1l-0.2-1l2.2-1.6h-3.1l-4.1-2.1l0.6-1.1l-3.5,1.5l2-5.7l-1.5,2l-3.3,4l1.8-6 l-4.4,5.7l1.8-6.8l-3.8,4.3l-0.3-2.5l-4.4,4.1l-3.5-5.2l0.1,2.2l-2.3-0.8l0.5,3.2l-4.8-6.6l2,7.7l-6.5-8.2l1.4,3.8l1,4.8l-3.5-3.5 l0.8,3.4l-4,1.5h-3.1l2.6,1.8l-0.4,1.6l-3.9-0.1l3.2,2.6l-0.5,1.8l-2-0.8l1.5,3.1l-0.5,2.2L119.5,111.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M179.6,287.9c0,0-13.1,5-39.5,4.7c0,0-29.2-2.4-38.5-4.6l-0.4,5.3l-1.4,5.5c0,0-9.1,36.7-10.2,51.2l23.1,0.1 c0,0-6.1-2.9-7-22.6c0,0,11.9,11.5,29.9,14.3c0,0-21.6-6.5-28.4-21.1c0,0-0.9-17,4-23.4c0,0,35.5,2.9,51.9-0.6 c0,0-32.9,1.7-45.4-1.1c0,0,0.8-2.6,3.6-3.3l19.5,1.7c0,0,30.8-1.1,39.7-4.3L179.6,287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M128.2,325.6c0,0,23.7-2.6,34.1-19.8C162.2,305.9,152.3,327.5,128.2,325.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M134.2,350v-5.7l-4.6-2.5c0,0,11.4,3.3,18.7-4.5l1.9-9.6l2.7,11.1l4.6,0.8c0,0-12.2,5.3-17.3,6 c0,0,16.9-2.5,23.8-7.8c0,0-3.4,4.4-12.9,8.3v3.9L134.2,350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M167.3,321.7c0,0,11.9-12.1,14.3-26.4c0,0,4.8,14.8,11.1,54.7h-8.4c0,0,2.3-17.5-3.7-41.2 C180.5,308.8,179.4,313.6,167.3,321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M169.6,295.8l7.3,0.9c0,0,1.5,3.8,0,8.2c0,0,2.6-5.6,3-11C179.9,293.9,175.2,295,169.6,295.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.7,148l-0.3-0.8l0.6-0.2l8.8-13.7l0.7-7.1l2.4-0.9l3.2-8l-0.5-4.7l-1.4-1.5l-2.3,0.5l1.1-5.9l2-10.4 l-0.6-3.1c-2.7-9-12.2-13.8-12.3-13.8c-6-3-11.3-2.7-11.4-2.7c-4.3,0-8.5,1.1-12.5,3.3c-0.1,0-9,5-11.5,12l-0.6,4.2l2.2,9.7 l1.4,7.1L118,111l-1.3,1l-1.1,4.7l3.4,8.2l2.1,1.2l0.7,7.1l7,10.9l-0.7,0.5l-7.1-11l-0.6-6.9l-2-1.1l-3.6-8.8l1.3-5.3l1.9-1.5 l0.8,0.3l-1.1-5.5l-2.2-9.8l0.7-4.4c2.6-7.3,11.5-12.3,11.9-12.5c4.1-2.3,8.4-3.4,12.8-3.4c0.2,0,5.5-0.3,11.8,2.8 c0.4,0.2,9.9,5,12.7,14.4l0.7,3.3l0,0.1l-2.9,15.2l1.6-0.3l2,2l0.5,5.2l-3.5,8.5l-2.2,0.8l-0.6,6.8l-9.1,14.2L150.7,148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.7,148l-0.3-0.8l0.7-0.3l8.8-13.7l2.7-28.5l-2.1-9.4c-11.1-1.6-19.5,0-19.6,0l-0.1,0l-0.1,0 c-12.4-1.5-18-0.4-19.1-0.2l-2.5,9.5l2.7,28.5l6.9,10.8l-0.7,0.5l-7-11l0-0.1l-2.7-28.7l2.7-10.1l0.2-0.1 c0.2-0.1,5.5-1.6,19.6,0.1c0.8-0.2,9.2-1.6,20.1,0l0.3,0l2.3,10.1l0,0.1l-2.7,28.8l-9.1,14.2L150.7,148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M124.8,146.7l-0.8-0.2c0.5-2.1,0.8-5,0.9-7.2l0.1-1.3l3.8,6l-0.7,0.5l-2.4-3.8 C125.5,142.7,125.2,145,124.8,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.7,148l-0.3-0.8l0.7-0.3l5.2-8.1l0.2,1.1c0.4,2.4,0.9,4.2,1.3,5.5c0.1,0.4,0.2,0.7,0.3,1l-0.8,0.2 c-0.1-0.3-0.2-0.6-0.3-1c-0.3-1.1-0.8-2.6-1.2-4.6l-4.2,6.5L150.7,148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M154.9,158.6l-0.6-0.6c2.4-2.2,4.3-4.8,5.7-7.7l-2.2-2.8c-0.6,1.2-2,3.8-4.8,6.3l-0.6-0.6 c3.6-3.2,4.8-6.6,4.8-6.7l0.3-0.7l3.4,4.4l-0.1,0.2C159.5,153.4,157.5,156.2,154.9,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M142.9,184.9l-5.6-2l0-0.3c-0.3-6,0.1-11.2,1.2-15.6l0.8,0.2c-1.1,4.2-1.5,9.3-1.2,15.1l3.9,1.4 c0-1.7-0.1-6.7,0.6-11.6l0.8,0.1c-0.9,6-0.6,12-0.6,12.1L142.9,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133.4,161.5c-8-3.6-12.3-10.8-12.5-11.1l-0.1-0.2l3.4-5l0.3,0.8c1.1,3.2,3.5,5.9,7.2,8.1l-0.4,0.7 c-3.5-2.1-6-4.7-7.3-7.8l-2.2,3.2c0.8,1.3,5,7.4,12,10.5L133.4,161.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "190.3,182.7 185.1,149.6 179.7,149 170.3,149.6 165.8,149.5 162.6,148.9 159.8,149.6 159.6,148.8  162.5,148 165.8,148.6 170.3,148.8 179.7,148.1 185.8,148.8 191.2,182.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M147,292.8c-11.6,0-26.5-1.1-45.6-4.4l-0.1,0l-2.4-2.8l0-0.1l-5.6-83.9l-2.4-5.6l-1.7-7.6l0.8-0.2l1.6,7.6 l2.4,5.7l5.6,83.8l2,2.3c56.3,9.7,76.9,0.3,78.1-0.3l2.3-2.2l4.9-75.2l0.8,0.1l-4.9,75.5l-2.7,2.6 C180.1,288.1,170.8,292.8,147,292.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "116.8,149.7 111.7,149.3 103.2,148.9 95.4,149.7 95.3,148.9 103.2,148 111.7,148.4 116.7,148.9  119.2,148 122.2,148.6 122,149.4 119.3,148.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "178.5,175.7 178.3,170.9 169.6,170.8 169.6,169.9 179.1,170 179.3,175.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "159.7,204.5 156.5,199.9 156.5,199.8 155.4,180.8 156.2,180.7 157.3,199.6 160.1,203.6 177.5,202.4  177.9,201.4 178.7,201.7 178.1,203.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.8,205.7c-2.3,13.6-5.1,27.1-8.3,40.5l-1.2,5l-1.3,5c-0.4,1.7-0.9,3.3-1.4,5c-0.5,1.6-1,3.3-1.5,4.9 l-1.7,4.9l-1.9,4.8c-0.7,1.6-1.5,3.1-2.2,4.7c-0.2,0.4-0.4,0.8-0.6,1.1l-0.7,1.1l-1.3,2.2l-0.1,0l1.2-2.3l0.6-1.1 c0.2-0.4,0.4-0.8,0.5-1.2c0.7-1.6,1.4-3.2,2-4.8l1.8-4.8l1.6-4.9c0.6-1.6,1-3.3,1.5-4.9c0.5-1.6,1-3.3,1.4-5l1.4-5l1.3-5 c1.7-6.7,3.3-13.4,4.8-20.1C180,219.2,181.4,212.4,182.8,205.7L182.8,205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.1,203.4c3.5,13.7,7.2,27.4,11,41l2.9,10.2c1,3.4,2,6.8,3,10.2l1.5,5.1l1.6,5.1c0.6,1.7,1.1,3.4,1.7,5 l0.9,2.5l1,2.4l-0.1,0c-1.7-3.1-2.9-6.5-4.1-9.8c-1.2-3.3-2.3-6.7-3.3-10.1c-1-3.4-2-6.8-3-10.2l-2.8-10.3 C104.7,230.9,101.3,217.2,98.1,203.4L98.1,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M144.8,297.7c-23.9,0-43.4-3.9-43.7-3.9l0.2-0.8c0.4,0.1,43,8.6,79.7,0.3l0.2,0.8 C169.1,296.7,156.4,297.7,144.8,297.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.4,324.5c1.7-0.4,3.4-0.8,5.1-1.4c0.8-0.3,1.7-0.6,2.5-0.9c0.8-0.4,1.6-0.7,2.4-1 c0.8-0.4,1.6-0.8,2.4-1.2l2.3-1.3l2.2-1.4c0.7-0.5,1.4-1,2.1-1.5c0.4-0.3,0.7-0.5,1.1-0.8l1-0.8c0.7-0.6,1.4-1.1,2-1.7l1.9-1.8 c0.3-0.3,0.6-0.6,0.9-1l0.9-1c2.4-2.6,4.3-5.6,6.2-8.6c-0.4,0.8-0.8,1.6-1.2,2.4c-0.4,0.8-0.8,1.6-1.3,2.3c-1,1.5-2,3-3.1,4.3 c-2.2,2.8-4.9,5.2-7.7,7.4c-2.9,2.1-6,3.9-9.3,5.3C134.4,323.1,130.9,324.2,127.4,324.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.8,294.9c-0.5,2.7-1.3,5.3-2.4,7.9c-1,2.5-2.3,5-3.7,7.3c-0.7,1.2-1.5,2.2-2.3,3.4 c-0.9,1-1.7,2.1-2.7,3.1c-1.8,2-4,3.7-6.2,5.2c2.2-1.6,4.3-3.3,6-5.4c1-1,1.7-2.1,2.6-3.1c0.8-1.1,1.6-2.2,2.2-3.4 c1.4-2.3,2.6-4.7,3.5-7.3c0.9-2.5,1.7-5.1,2.1-7.7L181.8,294.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.4,323.1c1.9,2.1,4,4,6.2,5.7c2.2,1.7,4.5,3.4,6.9,4.8c2.4,1.4,4.9,2.7,7.5,3.8c2.5,1.2,5.2,2.2,7.8,3.2 l0,0.1c-2.8-0.6-5.5-1.4-8.1-2.5c-2.6-1.1-5.1-2.5-7.5-4c-2.4-1.5-4.7-3.2-6.8-5C112.2,327.4,110.2,325.4,108.4,323.1L108.4,323.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139.4,350.1l0.1-4.4l0-0.3l0.3,0c3.9-0.6,7.8-1.5,11.6-2.5c1.9-0.5,3.8-1.1,5.7-1.8 c1.9-0.7,3.7-1.5,5.3-2.7c-1.6,1.2-3.4,2.1-5.2,2.8c-1.9,0.7-3.7,1.4-5.6,1.9c-3.8,1.1-7.7,2.1-11.6,2.8l0.3-0.4l0.1,4.4H139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116.5,151.4l3.3,8.5c1.1,2.8,2.2,5.6,3.4,8.4c1.1,2.8,2.4,5.5,3.7,8.3l1,2l1.1,2c0.4,0.7,0.8,1.3,1.2,1.9 c0.4,0.6,0.9,1.2,1.3,1.8c-2.2-2.1-3.8-4.8-5.2-7.5c-1.4-2.7-2.7-5.4-3.9-8.2c-1.1-2.8-2.2-5.6-3.2-8.5 C118.2,157.2,117.3,154.3,116.5,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.1,350.5l0-0.5c1.4-17,11.5-56.4,11.6-56.8l0.5-5.7l0.5,0.1c56.4,9.7,77,0.3,78.1-0.3l0.8-0.7l0.9,6.9 c5.2,17.6,11.5,56,11.6,56.4l0.1,0.5h-0.5L89.1,350.5z M102,288.5l-0.4,4.8c-0.1,0.5-10,39.1-11.6,56.3l102.1-0.1 c-0.8-4.6-6.6-39.4-11.5-55.8l0-0.1l-0.7-5.5C177.1,289.5,155.8,297.7,102,288.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M67.8,194.4h-5.7l-5-8.2l-3.4-15.3l-4.6-7l-1.3-4.5c-3.1-11.1-3.1-23.8-3.1-24l-0.7-8.8l0.8-0.1l0.7,8.8 c0,0.2,0,12.7,3.1,23.8l1.3,4.5l4.6,7l3.4,15.3l4.7,7.6h5.1l5.4-2.3l9.5-1.8l2.2-1.6l4.3,0.3l5.2-6.3l3.4-23.5l-2.6-8.8l-10.8-5.2 l-9.1,2.7H71l-3.2-2.1l-2.6-10.4L62.4,122l0.8-0.2l2.7,12.6l2.5,10l2.7,1.8H75l9.2-2.7l11.5,5.5l2.8,9.4L95,182.3l-5.7,6.8 l-4.4-0.3l-2.2,1.5l-9.6,1.8L67.8,194.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "61.3,117 60.7,114.2 66.2,105.7 65.2,95.7 64.1,94.7 64.7,94.1 66,95.3 67.1,105.9 61.6,114.3  62.2,116.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "59.8,100.5 59.2,99.8 60.7,98.5 60.7,95.4 56.2,91.1 53.6,91.1 52.4,91.5 52.2,90.6 53.5,90.3  56.5,90.3 61.6,95 61.6,98.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "46.7,92.7 52.2,90.6 52.4,91.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "58.7,106.1 58.2,105.4 60,104.2 60,101 55.1,97.2 53.2,97.2 52.5,97.4 52.3,96.6 53.1,96.4  55.4,96.4 60.9,100.6 60.9,104.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "41.4,99.2 52.3,96.6 52.5,97.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "52.7,91.1 50.2,87.6 50.3,87.7 46.7,87 50.3,87.3 50.4,87.3 50.5,87.4 53.3,90.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M44.4,122h-0.9v-1.9l-4.2-4.1l-3.3-7.7l1.2-3l-1-2.1l1.1-3.2l0.1-5.4l5.7-2.5v-9.5l5.8-2.7l7.7,2.6l4.4,5.7 l0,2.5c-0.5,1.2-2.4,1.9-2.6,2L58.1,92c0.5-0.2,1.7-0.7,2.1-1.5v-2l-4.1-5.3L49,81l-5,2.3v9.5l-5.7,2.5l-0.1,5l-1,2.9l1,2.1 l-1.3,3l3.1,7.3l4.3,4.1V122z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "52.3,111.4 43.4,111 52.3,110.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "53.1,111.4 52.3,111.4 52.3,110.5 53,110.5 57.9,109.2 58.5,106.5 54.3,104.2 53.6,104.2  53.6,103.3 54.5,103.3 59.4,106.1 58.6,109.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "41.4,103.8 53.6,103.3 53.6,104.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M44.1,119.5c1.2,0.5,2.5,0.8,3.8,1c1.3,0.2,2.6,0.2,3.9,0c1.3-0.2,2.5-0.7,3.6-1.4c1.1-0.7,2-1.8,2.7-2.9 c-0.7,1.1-1.5,2.3-2.6,3c-1.1,0.8-2.3,1.4-3.7,1.7c-1.3,0.3-2.7,0.4-4.1,0.3c-1.4-0.1-2.7-0.4-4-0.8L44.1,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M77.6,182.6h-6.8c-9.1-0.2-16.8-11.2-17.2-11.6l0.7-0.5c0.1,0.1,7.9,11.1,16.5,11.3h6.8V182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73.5,191.9l-0.7-0.4l4.4-8c0.1-1.1,1.6-14.1,0.8-22.5c-0.8-8.5-7-14-7.1-14.1l0.6-0.6 c0.3,0.2,6.5,5.7,7.4,14.6c0.8,8.8-0.8,22.6-0.9,22.7l0,0.2L73.5,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.2,191.8l-0.7-0.5l4.2-5.4l1.4-3.1c0.1-0.7,1.4-8.8,1.4-20.4c0-11.9-6.6-15.3-6.6-15.4l0.4-0.8 c0.3,0.1,7.1,3.6,7.1,16.1c0,12.2-1.4,20.5-1.4,20.6l0,0.1l-1.5,3.3L75.2,191.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "59,175.8 60.9,185.4 60.9,185.3 63.9,190.9 63.9,190.9 68.3,191.6 63.8,191.1 63.8,191.1 63.8,191  60.5,185.6 60.5,185.5 60.4,185.5 58.2,176  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M68.5,144.6c0.2,2.5,0.2,5,0.2,7.5c-0.1,2.5-0.4,5-1,7.4c0.5-2.5,0.6-5,0.6-7.4c-0.1-2.5-0.2-5-0.6-7.4 L68.5,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M77.3,145.6c2,0.8,3.6,2.1,5,3.7c1.3,1.6,2.3,3.4,3,5.3c0.8,1.9,1.1,3.9,1.4,5.9c0.1,1,0.1,2,0.2,3l-0.1,3 l-0.1-3c-0.1-1-0.2-2-0.3-3c-0.4-2-0.7-4-1.6-5.8c-0.8-1.8-1.8-3.6-3.1-5c-1.3-1.4-3-2.7-4.8-3.3L77.3,145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M50.9,128.2c-2.1,0-4.5-0.4-7.1-1.4l-0.1-0.1l-1.2-1l-0.1-4.4l2-1.2l0,1.5c1.5,0.7,10.2,4.2,16.9-4.9 l-0.3-1.6l0.5,0c0,0,1,0,1.5,0.9c0.5,0.8,1,2.1,0.9,4.3c0,0.5-0.6,1.5-0.7,1.7C63.1,122.2,59,128.2,50.9,128.2z M44.2,126 c12,4.6,18-4,18.3-4.3c0.2-0.4,0.5-1,0.5-1.3c0.1-1.9-0.3-3.1-0.7-3.8c-0.1-0.1-0.1-0.2-0.2-0.3l0.1,0.7l-0.1,0.2 c-7.7,10.6-18.2,5.2-18.3,5.2l-0.2-0.1l0-0.5l-0.3,0.2l0.1,3.5L44.2,126z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "226.6,227.3 226.4,227.3 214,225.6 198.4,220.8 153.4,179.2 154,178.5 199,220.1 214.2,224.8  226.3,226.4 234.4,220.2 236.1,212.7 234.3,201.9 230.2,190.3 226,183.3 213.7,167 212.9,161.1 206.2,151.7 191,148.3  185.6,149.8 185.4,149 191,147.4 206.7,151 213.8,160.8 214.5,166.6 226.7,182.9 230.9,190 235.2,201.7 237,212.7 235.1,220.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.9,
    y: 159.2,
    transform: "matrix(0.5048 -0.8632 0.8632 0.5048 -63.1 239.6144)",
    className: "st12",
    width: 0.9,
    height: 31.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "234.4,202 230.4,196.2 215.9,188.5 201.4,188.5 190.5,183 190.9,182.3 201.6,187.7 216.1,187.7  231,195.6 235.1,201.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.2,183.1c0.5-2.4,1.2-4.8,2-7.1c0.8-2.3,1.8-4.5,3-6.7c1.2-2.1,2.6-4.1,4.4-5.8c0.9-0.9,1.8-1.6,2.8-2.3 c1-0.7,2.1-1.2,3.2-1.7c-1.1,0.5-2.2,1.1-3.2,1.7c-1,0.7-1.9,1.5-2.7,2.4c-1.7,1.8-3,3.8-4.1,5.9c-1.1,2.1-2,4.4-2.8,6.7 c-0.7,2.3-1.4,4.6-1.7,7L191.2,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214.2,167.2c-1.6,0.6-3.2,1.3-4.8,2.1c-1.6,0.8-3.1,1.6-4.6,2.6c-1.5,0.9-2.9,2-4.3,3.1 c-1.4,1.1-2.6,2.4-3.7,3.7c1.1-1.4,2.3-2.7,3.6-3.9c1.3-1.2,2.7-2.3,4.2-3.3c1.5-1,3-1.9,4.5-2.8c1.6-0.8,3.1-1.6,4.8-2.3 L214.2,167.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "232.1,195.5 220.5,187.5 211.2,187.1 204,188.5 203.8,187.7 211.1,186.3 211.1,186.3 220.8,186.6  232.6,194.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.6,186.3c2-0.6,4-1.1,6.1-1.5c2-0.4,4.1-0.7,6.2-0.9c2.1-0.2,4.1-0.3,6.2-0.3c2.1,0,4.1,0.2,6.2,0.4 c-2.1-0.2-4.1-0.3-6.2-0.2c-2.1,0-4.1,0.2-6.2,0.5c-2,0.3-4.1,0.6-6.1,1.1c-2,0.5-4,1-5.9,1.7L198.6,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M190.7,176c-0.2-0.9-0.3-1.8-0.3-2.7c0-0.9,0-1.8,0.1-2.7c0.1-1.8,0.2-3.6,0.5-5.4l0.1,0 c-0.1,1.8-0.1,3.6-0.1,5.4c0,0.9,0.1,1.8,0.1,2.7C191,174.2,190.9,175.1,190.7,176L190.7,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M201.6,187.7c2.2,0.5,4.3,1.1,6.4,1.9c2.1,0.7,4.1,1.6,6.1,2.5c2,0.9,3.9,2,5.8,3.1c1.9,1.2,3.6,2.5,5.3,3.9 c-1.7-1.4-3.5-2.7-5.4-3.8c-1.9-1.1-3.8-2.1-5.9-2.9c-2-0.9-4.1-1.6-6.1-2.3c-2.1-0.6-4.2-1.2-6.3-1.6L201.6,187.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "131,153.9 133,150.2 133,150.4 130.3,147.3 133.3,150.1 133.4,150.2 133.4,150.4 131.8,154.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "136.5,145 138.9,146.5 138.9,146.5 138.9,146.5 140.1,147.8 138.7,146.7 138.7,146.8 136.1,145.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.1,
    y: 141.7,
    transform: "matrix(0.4467 -0.8947 0.8947 0.4467 -55.1612 196.7552)",
    className: "st12",
    width: 0.9,
    height: 2.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "140.3,141.6 142.5,143 142.5,143 144.4,144.7 142.3,143.4 142.3,143.4 139.9,142.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.8,
    y: 138.4,
    transform: "matrix(0.4754 -0.8798 0.8798 0.4754 -51.6443 192.1194)",
    className: "st12",
    width: 0.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M161.5,168.7L161,168c1.1-0.8,2-1.1,2.4-1.3v-1l-4.6-3.2c-0.8,0.2-1.7,0.6-2.5,1.2l-0.5-0.7 c1-0.7,1.9-1.1,2.9-1.4l0.2,0l5.2,3.6v2.1l-0.3,0.1C164,167.4,162.9,167.7,161.5,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M153.9,179.6h-2.3l-3.6-3.5l0.1-0.2c0-0.1,1-3.2,2.8-6.5l0.7,0.4c-1.5,2.7-2.4,5.3-2.6,6.1l3,2.9h1.4 c0.8-2,1.7-3.9,2.7-5.5l0.7,0.5c-1.1,1.6-2,3.5-2.7,5.6L153.9,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.2,173.9c-2.6,0-4.8-1.8-5.4-4.3l0.8-0.2c0.5,2.1,2.4,3.6,4.6,3.6l0.2,0l0,0.9 C156.3,173.9,156.2,173.9,156.2,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.4,173.9l0-0.9c2.5-0.1,4.5-2.1,4.5-4.7c0-2.6-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7 c0,0.3,0,0.7,0.1,1l-0.8,0.2c-0.1-0.4-0.1-0.8-0.1-1.2c0-3,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5 C161.7,171.4,159.4,173.8,156.4,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M84.6,188c1.2-0.9,2.3-2,3.2-3.2c1-1.2,1.8-2.5,2.5-3.9c0.7-1.4,1.3-2.8,1.7-4.3c0.2-0.7,0.4-1.5,0.5-2.3 c0.1-0.8,0.2-1.5,0.3-2.3c-0.1,0.8-0.1,1.6-0.2,2.3c-0.1,0.8-0.2,1.5-0.4,2.3c-0.3,1.5-0.9,3-1.5,4.4c-0.6,1.4-1.5,2.8-2.4,4.1 c-0.9,1.3-2,2.5-3.3,3.5L84.6,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.8,156.1c0,0,4.3-3.5,5.7-5.8c0,0-2.9,5.1-5.1,7.2L153.8,156.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "148.9,174.9 142.8,172.5 131.3,159.1 131,154.2 128,149.4 128,143.3 130,142.1 131.1,138.5  134.4,138.5 137.5,137.4 140.2,137.4 149.4,143.3 156,160.7 157.9,162.2 157.4,162.9 155.3,161.2 148.7,143.8 140,138.3  137.6,138.3 134.4,139.3 131.7,139.3 130.7,142.7 128.8,143.8 128.8,149.2 131.8,154 132.1,158.8 143.3,171.7 149.2,174.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M136.4,145.9l-4.4-2.2l0.3-0.4c3.3-5,7.6-5.8,7.8-5.9l0.2,0l4.2,2.7l-0.7,0.3c-4.8,2.2-7,5.2-7.1,5.2 L136.4,145.9z M133.2,143.4l2.9,1.5c0.7-0.8,2.7-3,6.5-4.9l-2.6-1.7C139.3,138.5,136,139.5,133.2,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M141.2,139l-1.2-0.8h-2.4l-0.7,0.3v-3.6h4.3V139z M137.7,137.4h2.5l0.1,0.1v-1.7h-2.6V137.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "137.3,136.5 134.7,137.6 136.7,133.8 138.3,133.2 138.9,133.9 139.5,133.2 141.4,133.8 143.5,137.6  140.7,136.3 140.8,135.4 137.3,135.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "78.1,94.9 60.5,94.9 60.5,94 77.3,94 77.3,46.2 49.7,46.2 49.4,80.5 48.5,80.5 48.8,45.3 78.1,45.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 87.4,
    className: "st12",
    width: 0.9,
    height: 4.6
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#D3A31E",
      strokeWidth: 6,
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameOver);
export default __webpack_public_path__ + "static/media/game-over.f635c768249e7c09fbdea6bb2c083180.svg";
export { ForwardRef as ReactComponent };